import { ConfigurationService } from '@/config/configuration-service';
import { getAxiosInstance } from '@chr/online-shared-microsite-core';
import { IPoRequest, IPoRequestFilter } from './interfaces/po-request';
import { ISendUnconfirmedItemsRequest } from './index';
import { USER_FILTER_KEY } from '@/app-constants';
import { ISearchOrderVerificationDetailsResponse } from './interfaces/po-response';
import { AxiosInstance } from 'axios';

export const searchOrderVerificationDetails = async (request: IPoRequest) => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();

  const { bucketTypeId, ...requestProps } = request;

  const response = await axiosInstance.post<ISearchOrderVerificationDetailsResponse>(`${poApiUri}/OrderVerificationDetails/Search`, {
    ...requestProps,
    bucketType: bucketTypeId
  });

  return response.data;
};

export const getUserDefinedFilters = () => {
  const filterString = localStorage.getItem(USER_FILTER_KEY);

  if (filterString) {
    const filters = JSON.parse(filterString);

    return filters.default;
  }

  return [];
};

export const saveUserDefinedFilters = (filters: IPoRequestFilter[]) => {
  const jsonFilters = JSON.stringify({ default: filters });

  localStorage.setItem(USER_FILTER_KEY, jsonFilters);
};

export const approveAllPoItems = async (request) => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();

  const postPoUri = `${poApiUri}/PurchaseOrders/Acknowledgement/${request.poId}`;
  const response = await axiosInstance.post(postPoUri, {
    customerCode: request.customerCode,
    purchaseOrderId: request.poId
  });

  return response.data;
};

export const sendUnconfirmedItems = async (request: ISendUnconfirmedItemsRequest) => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const configs = await ConfigurationService.getConfiguration();
  const response = await axiosInstance.post(`${configs.poApiUri}/Notifications`, {
    ...request
  });

  return response.data;
};
